import { LinkButton, ModalWindow, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { Price, Error, Loading, DeactivatedLabel, KeyValTable } from '../../commonComponents';
import { OfferGallery } from '../OfferGallery';
import * as styles from './styles.css';
import { TOfferFromHistoryData } from '../../../../types';

interface IOfferFromHistoryProps {
  isOpen: boolean;
  onClose(): void;
  title?: string;
  offer?: TOfferFromHistoryData | null;
  deactivatedTitle: string | null;
  isLoading?: boolean;
  isError?: boolean;
  onOfferLinkClick: VoidFunction;
}

export const OfferFromHistory: React.FC<IOfferFromHistoryProps> = props => {
  const { isOpen, offer, onClose, title, isLoading, isError, deactivatedTitle, onOfferLinkClick } = props;

  return (
    <ModalWindow
      open={isOpen}
      onClose={onClose}
      title={title}
      content={
        <>
          {offer && (
            <div data-name="OfferFromHistoryDetail">
              {offer.images && (
                <div className={styles['gallery']}>
                  <OfferGallery images={offer.images} />
                </div>
              )}
              <div className={styles['price']}>
                <Price diff={offer.prices.priceDiff} subprice={offer.prices.priceSqm}>
                  {offer.prices.price}
                </Price>
                {deactivatedTitle && <DeactivatedLabel title={deactivatedTitle} />}
              </div>
              <div className={styles['address']}>
                <UIText2 color="gray60_100">{offer.address}</UIText2>
              </div>

              {!!offer.dealConditions && (
                <KeyValTable title="Условия сделки" className={styles['features']} table={offer.dealConditions} />
              )}

              <KeyValTable
                className={styles['features']}
                table={offer.features}
                title={offer.dealConditions ? 'Общая информация' : undefined}
              />
            </div>
          )}
          {isLoading && <Loading />}
          {isError && <Error handleClick={() => window.location.reload()} />}
        </>
      }
      footer={
        offer?.link && (
          <LinkButton
            href={offer.link}
            theme="fill_secondary"
            target="_blank"
            rel="noreferrer"
            fullWidth
            onClick={onOfferLinkClick}
          >
            Посмотреть объявление
          </LinkButton>
        )
      }
    />
  );
};
